<template>
  <div v-wave class="flex flex-row h-min gap-3 justify-center md:w-[400px] md:bg-white border rounded-md md:cursor-pointer hover:bg-gray-50 p-3" @click="onClick">
    <img :src="product.images[0] ?? DEFAULT_LOGO_IMAGE" class="aspect-square rounded-xl w-20 h-20" :alt="`image of ${product.name}`">
    <div class="flex flex-grow flex-col">
      <span class="font-medium text-start">{{ product.name }}</span>
      <span class="text-sm text-gray-400 ">{{ product.categories.join(', ') }}</span>
      <div class="flex flex-wrap justify-between items-center gap-4 mt-auto">
        <span class="font-medium" v-if="!product.discountedPrice">₪{{ product.price }}</span>
        <div class="flex gap-2 items-center" v-else>
          <span class="font-medium text-purple-400">₪{{ product.discountedPrice }}</span>
          <span class="text-sm line-through">₪{{ product.price }}</span>
        </div>
      </div>
    </div>
    <div class="flex flex-col rounded-md py-2 px-4 self-center border-gray-300 border-solid border h-max justify-center items-center gap-1">
      <span class="font-medium text-gray-600">מלאי</span>
      <span
        class="text-gray-400 text-sm font-medium">{{
          product.availableStock > 0 ? `${product.availableStock} ` : 'אזל'
        }} </span>
    </div>

  </div>
</template>

<script setup lang="ts">
import {useAdminStore} from "@app/stores";
import {useToast} from "vue-toastification";
import {PropType} from "vue";
import {IShopItem} from "@torim-app/types";
import { DEFAULT_LOGO_IMAGE } from '../../../../../../../website/src/app/types';

const adminStore = useAdminStore();
const toast = useToast();

const emits = defineEmits(['onClick'])
const props = defineProps({
  product: {type: Object as PropType<IShopItem>, required: true}
})

const onClick = () => {
  emits('onClick', props.product);
}

</script>

<style scoped lang="scss">

</style>
